
    export default 
    {
    "refresh_mask": {
        "title": "Status-Updates",
        "dec": "Bitte aktualisieren Sie die Seite, um den Status zu aktualisieren."
    }
}